export interface IStartupSequence {
    name: ESyncNames,
    status: EStartupSequenceStatus
}

export enum EStartupSequenceStatus {
    Started = 'started',
    InProgress = 'in_progress',
    Completed = 'completed',
    Cancelled = 'cancelled',
}

export enum ESyncNames {
    SyncUsers = 'sync_users',
    SyncPscCodes = 'sync_psc_codes',
    SyncNaicsCodes = 'sync_naics_codes',
}